import IncidentLinkButton from "../Components/IncidentLinkButton";
import moment from "moment";

//The idNames need to match the row names in parse function

export const addressHistoryHeaders = [
  { title: "Incident Number", idName: "incidentNumber", show: true },
  { title: "Call Type", idName: "callTypeName", show: true },
  { title: "Call Time", idName: "callTime", show: true },
  { title: "Badge", idName: "primaryBadge", show: true },
  { title: "From", idName: "from", show: true },
  { title: "To", idName: "to", show: true },
  // { title: 'Last Updated', idName: 'updatedAt', show: true },
];

export function parseAddressHistory(arr, clickHandler, userRoles) {
  let tempRows = [];
  if (Array.isArray(arr) && arr.length > 0) {
    arr.map((incident) => {
      const incidentId = incident?.id;
      const incidentNumber = (
        <IncidentLinkButton
          handleIncidentOpening={clickHandler}
          incident={incident}
          userRoles={userRoles}
        />
      );
      const callTypeName = incident?.classification?.name;
      const callTime = incident?.callTime
        ? moment
            .utc(incident?.callTime, "YYYY-MM-DD HH:mm:ss UTC")
            .local()
            .format("MM/DD/YYYY HH:mm")
        : "";
      const primaryBadge = incident?.officerIncidentSpecifics.find(
        ois => ois?.primaryOfficer
      )?.officer?.deptAttribute?.badge;
      const from = incident?.incidentDetail?.occurredFrom
        ? moment
            .utc(
              incident?.incidentDetail?.occurredFrom,
              "YYYY-MM-DD HH:mm:ss UTC"
            )
            .local()
            .format("MM/DD/YYYY HH:mm")
        : "";
      const to = incident?.incidentDetail?.occurredTo
        ? moment
            .utc(
              incident?.incidentDetail?.occurredTo,
              "YYYY-MM-DD HH:mm:ss UTC"
            )
            .local()
            .format("MM/DD/YYYY HH:mm")
        : "";

      tempRows.push(
        createAddressData(
          incidentId,
          incidentNumber,
          callTypeName,
          callTime,
          primaryBadge,
          from,
          to
        )
      );
      return null;
    });
    return tempRows;
  } else {
    return tempRows;
  }
}

function createAddressData(
  incidentId,
  incidentNumber,
  callTypeName,
  callTime,
  primaryBadge,
  from,
  to
) {
  return {
    incidentId,
    incidentNumber,
    callTypeName,
    callTime,
    primaryBadge,
    from,
    to,
  };
}
